import React, { useEffect, useRef, useState } from 'react'

import { Box, Button, Card, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { grey } from '@mui/material/colors'
import { LoginProps } from './LoginProps'

function MediumLogin(props: LoginProps) {
  const emailInputRef = useRef<any>(null)
  const emailPasswordRef = useRef<any>(null)
  const StyledImg = styled('img')({})
  useEffect(() => {
    props.userEmail ? emailPasswordRef?.current?.focus() : emailInputRef?.current?.focus()
  }, [])

  return (<>
    <Grid container spacing={10} sx={{
      backgroundImage: 'url(/hex-grid-background-grey.svg)',
      backgroundSize: 'cover',
      display: { xs: 'none', md: 'flex' }
    }}>
      <Grid item xs={6} sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100vh',
        maxHeight: '100vh',
        overflow: 'hidden'
      }}>
        <Box sx={{
          display: 'flex', flexDirection: 'column',
          justifyContent: 'center', alignContent: 'center',
          justifyItems: 'center', alignItems: 'center',
          marginTop: '100px',
        }}>
          <Box sx={{ alignSelf: 'flex-start', }}>
            <StyledImg src="/img/q.svg" sx={{
              width: '86px',
              marginLeft: '100px',
              padding: '10px'
            }} />
            <Typography variant='h5' component="span" sx={{ bottom: '12px', position: 'relative', color: grey[700] }}>for Sales</Typography>
          </Box>
          <Typography variant='h4' sx={{ marginBottom: 5, fontWeight: 900 }}>Capture what matters most.</Typography>
          <StyledImg src="/Conversational-Intelligence-2.0-heroImg.png"
            sx={{ maxWidth: '100%', height: 'auto' }} />
        </Box>
      </Grid>
      <Grid item xs={6} sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100vh'
      }}>
        <Card sx={{ maxWidth: { xs: '250px', sm: '350px', md: '450px', lg: '550px', xl: '650px' }, padding: 6 }}>
          <Typography variant='h5' sx={{ textAlign: 'center', fontWeight: 800 }} marginBottom={2}>Welcome</Typography>
          <Typography variant='h5' sx={{ textAlign: 'center', color: grey[600] }}>Enter your email id and continue.</Typography>
          <form action="/login" method="post" id="form">
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 5 }}>
              <FormControlLabel labelPlacement="top" label="Email" componentsProps={{ typography: { variant: 'h6' } }}
                sx={{ alignItems: 'flex-start', minWidth: '75%', textAlign: 'center' }}
                control={<TextField name="email" placeholder='Email Address' ref={emailInputRef} autoFocus={true} sx={{ minWidth: { xs: '200px', sm: '300px', md: '400px', lg: '500px', xl: '600px' } }} />} />
              <Button type="submit" variant='contained' sx={{
                display: 'block', width: 350, marginTop: 5, marginBottom: 15,
                minWidth: { xs: '150px', sm: '250px', md: '350px', lg: '450px', xl: '550px' }, alignSelf: 'center'
              }}>
                Next
              </Button>
            </Box>
          </form>
        </Card>
      </Grid>
    </Grid>
  </>)
}
export default MediumLogin